import React from 'react';
import { ExternalLink } from 'lucide-react';

export default function Ziyarat() {
  const ziyaratServices = [
    {
      name: "Faiz-e-Haakimi",
      destinations: "Cairo, Mutah (Jordan), and Quds (Jerusalem)",
      url: "http://faizehaakimi.com/"
    },
    {
      name: "Faiz-e-Husaini",
      destinations: "India, Karbala/Najaf, and Haj-related information",
      url: "http://faizamerica.org/"
    },
    {
      name: "Faiz-e-Hatimi",
      destinations: "Yemen",
      url: "http://faizehatemi.com/"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="text-white py-16" style={{ background: 'linear-gradient(to right, #001f3f, #001f3f)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Ziyarat</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="bg-gray-50 rounded-lg p-12">
          <p className="text-gray-700 text-lg leading-relaxed mb-12">
            Use the following links to plan and book reservations for ziyarat trips to various sacred destinations.
          </p>

          {/* Services Grid */}
          <div className="space-y-6">
            {ziyaratServices.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-8 border-l-4 border-dawoodi-gold shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-2" style={{ color: '#001f3f' }}>
                      {service.name}
                    </h3>
                    <p className="text-gray-600 text-lg">
                      {service.destinations}
                    </p>
                  </div>
                  <a
                    href={service.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-8 py-3 text-white rounded-lg hover:opacity-90 transition-opacity font-medium"
                    style={{ backgroundColor: '#001f3f' }}
                  >
                    Visit Website
                    <ExternalLink size={18} className="ml-2" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
